var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view prosecco",attrs:{"data-name":"prosecco"}},[_c('ProseccoContent',{attrs:{"data":_vm.structure}}),_c('ProseccoHero',{attrs:{"title":_vm.title}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }